import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { getLanguageCode, DataTable, DealerCard } from '@triumph/shared';
import Label from 'components/_utility/Label';
import {
  getAddressFields,
  getBikeCondition,
  getFormData,
  getSelectedDealer,
  getSelectedMake,
  getSelectedModel,
} from 'src/redux/app/selectors';
import useLabel from 'src/hooks/useLabel';
import useDataLayer from 'src/hooks/useDataLayer';
import { Wrap, Title, DetailsWrap, Summary, Table, CollectionGuidance } from './OrderDetails.styled';

const OrderDetails = () => {
  const pushToDataLayer = useDataLayer();
  const getLabel = useLabel();
  const wrapRef = useRef();
  const selectedMake = useSelector(getSelectedMake);
  const selectedModel = useSelector(getSelectedModel);
  const bikeCondition = useSelector(getBikeCondition);
  const selectedDealer = useSelector(getSelectedDealer);

  const formData = useSelector(getFormData);
  const addressFields = useSelector(getAddressFields);
  const address = addressFields.reduce((prevAddress, addressField, addressFieldIndex) => {
    let newAddress = prevAddress + formData[addressField.id];

    if (addressFieldIndex !== addressFields.length - 1 && formData[addressField.id]) {
      newAddress += ', ';
    }

    return newAddress;
  }, '');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Wrap ref={wrapRef}>
      <Title>
        <Label name="orderDetailsTitleLabel"></Label>
      </Title>
      <DetailsWrap>
        <Table
          headerText={getLabel('personalInfoLabel')}
          tableData={[
            {
              term: getLabel('nameLabel'),
              definition: `${formData.firstName} ${formData.lastName}`,
            },
            {
              term: getLabel('addressLabel'),
              definition: address,
            },
            {
              term: getLabel('emailFieldLabel'),
              definition: formData.email,
            },
            {
              term: getLabel('phoneFieldLabel'),
              definition: formData.phone,
            },
          ]}
        />
        {formData.partExchange === 'yes' ? (
          <Table
            headerText={getLabel('partExchangeLabel')}
            tableData={[
              {
                term: getLabel('makeFieldLabel'),
                definition: selectedMake.name,
              },
              {
                term: getLabel('modelFieldLabel'),
                definition: selectedModel.name,
              },
              {
                term: getLabel('mileageFieldLabel'),
                definition: parseInt(formData.mileage, 10).toLocaleString(getLanguageCode()),
              },
              {
                term: getLabel('regLabel'),
                definition: formData.registration,
              },
              {
                term: getLabel('conditionFieldLabel'),
                definition: bikeCondition.value,
              },
            ]}
          />
        ) : null}
      </DetailsWrap>
      <Summary>
        <Label name="summaryClosingText"></Label>
      </Summary>
      <DataTable headerText={getLabel('collectionTitle')}></DataTable>
      <CollectionGuidance>
        <Label name="collectionGuidance"></Label>
      </CollectionGuidance>
      <DealerCard
        dealer={selectedDealer}
        markerImg="https://www.triumphmotorcycles.co.uk/_images/map/map-icon-triumph-a.png"
        labels={{
          openingTimesGuidance: getLabel('openingTimesGuidance'),
          visitDealerLabel: getLabel('visitDealerButtonText'),
          openingTimesLabel: getLabel('openingTimesTitle'),
          directionsLabel: getLabel('getDirectionsText'),
        }}
        onVisitClick={() => pushToDataLayer('visitDealer')}
        onDirectionsClick={() => pushToDataLayer('getDirections')}
        extended
      />
    </Wrap>
  );
};

export default OrderDetails;
